<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
<v-row>
  <v-col>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      color="primary"
    ></v-progress-linear>
  </v-col>
</v-row>
 <sequential-entrance fromTop>  
<v-row>
  <v-col
  sm="12" md="12" lg="12"
  >
    <base-material-card
      color="primary"
      icon="mdi-group"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Admin Management
        </div>    
      </template>
  <v-data-table
    :headers="headers"
    :items="getrels"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>Admins</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>             
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              New Admin
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                  <v-select
                    color="primary"
                    :items="currentusers"
                    outlined
                    label="Select Safe"
                    v-model="adminuser"  @change="onChangeUser($event)"
                  ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="600px">
          <v-card>
            <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>      
    </base-material-card>    
  </v-col>

</v-row>
 </sequential-entrance>
    
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      search: '',
      headers: [
        {
          text: 'Release',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Path',
          align: 'center',
          sortable: true,
          value: 'path',
        },        
        { text: 'Actions', value: 'actions', align: 'center' ,sortable: false },
      ],
      rels: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        path: '',
        key: '',
      },
      defaultItem: {
        name: '',
        path: '',
        key: '',
      },
      users: '',
      adminuser: ''
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Release' : 'Edit Release'
      },
      loading () {
        // return true
        return this.$store.getters.getloading
      },
      getrels () {
        this.rels = []
        this.rels = this.$store.getters.getreleases

        return this.rels
      },
      currentusers () {
        this.users = this.$store.getters.userprofiles
        return this.users.map(user => user.email)
      },      
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.rels = []
      this.$store.dispatch('loadUserProfiles')
      this.initialize()
    },

    methods: {
      initialize () {
        this.rels = this.$store.getters.getreleases
      },
      onChangeUser (value) {
        this.adminuser = value
      },
      editItem (item) {
        this.editedIndex = this.rels.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.rels.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.rels.splice(this.editedIndex, 1)
        // this.$store.dispatch('removerelease', this.editedItem)

        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.rels[this.editedIndex], this.editedItem)
          // this.$store.dispatch('updaterelease', this.editedItem)
        } else {
          this.rels.push(this.editedItem)
          // this.$store.dispatch('createrelease', this.editedItem)
        }
        this.$store.dispatch('loadUserProfiles')
        this.close()
      },
    },
  }
</script>
